import * as React from 'react'

import { Type } from '../../../Other/Type'
import Button from '../Button/Button'
import { DropdownButton } from '../DropdownButton/DropdownButton'
import { TestableInterface } from '../interfaces/TestableInterface'
import './Document.scss'

export interface DocumentProps extends TestableInterface {
  className?: string
  type?: 'Paper' | 'Panel'
}

export class Document extends React.Component<DocumentProps, null> {
  public static defaultProps: DocumentProps = {
    className: '',
    type: 'Paper',
  }

  public render(): JSX.Element {
    const buttons = []
    const others = []

    let children = []
    if (!Type.isArray(this.props.children)) {
      children.push(this.props.children)
    } else {
      children = this.props.children.slice()
    }
    children.forEach((child) => {
      if (child.type === Button || child.type === DropdownButton) {
        buttons.push(child)
      } else {
        others.push(child)
      }
    })

    const classes = ['Document Controlled', this.props.type, this.props.className]

    return (
      <div data-automation={this.props.automation} className={classes.join(' ')}>
        <div className="Buttons">{buttons}</div>
        <div className="DocumentContainer">{others}</div>
      </div>
    )
  }
}
